<template>
    <div class="main-container">
        <div v-if="lienCGU">
            <a :href="lienCGU" target="_blank" rel="noopener noreferrer">
                Consulter les conditions générales d'utilisation
                <v-icon color="primary">mdi-open-in-new</v-icon>
            </a>
        </div>
        <div v-if="lienFAQ">
            <a :href="lienFAQ" target="_blank" rel="noopener noreferrer" style="margin-top: 5px;">
                Consulter les questions fréquemment posées
                <v-icon color="primary">mdi-open-in-new</v-icon>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LiensUtiles",
        props: {
            lienCGU: { type: String, required: false},
            lienFAQ: { type: String, required: false}
        },
    };
</script>

<style scoped>
    .main-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>

